import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import QmModuleStyle from '../styles/qm.module.css';
require('highcharts/modules/accessibility')(Highcharts);

const InventoryGraph = ({ type = "monthly", simObj, isResult, setSimObj, summaryGraphData }) => {
  const [leftPosition, setLeftPosition] = useState(type == "monthly" ? 83 : type == "quarterly" ? 82 : 76);
  const bounds = { left: 0, right: 556 };
  const [xAxisLabelArray, setxAxisLabelArray] = useState([]);
  const [stepCount, setStepCount] = useState(0);
  const [monthlydata, setMonthlyData] = useState('');
  const [chart, setChart] = useState(null);
  let graphSettings = {};
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const setGraphData = () => {
    if (chart != undefined) {
      let inventoryMonthlyData = [];
      let inventoryQuarterlyData = [];
      let inventoryYearlyData = [];
      let newPoint = "";
      let existingData = "";
      let newData = "";
      chart?.yAxis != undefined && chart?.yAxis[0]?.update({ min: 0, max: undefined });
      let monthDays = 0;
      updateSeriesBasedOnWindowWidth();
      switch (type) {
        case "monthly":
          inventoryMonthlyData = simObj?.graphdata?.filter((data, index) => {
            if (data?.sm === simObj?.laststate?.statemonth) {
              return true;
            }
          });
          inventoryMonthlyData = (inventoryMonthlyData != undefined ? inventoryMonthlyData : []).map((data) => {
            return {
              x: data.sd,
              y: data.fr,
              date: getDate(data.cd),
              externalFailureRate: data.ef,
              internalFailureRate: data.if

            }
          });
          newPoint = inventoryMonthlyData[inventoryMonthlyData.length - 1]
          InventoryData["monthly"] = inventoryMonthlyData;
          if (chart?.series != undefined && InventoryData["monthly"].length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(InventoryData["monthly"]);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            newData = [...existingData, newPoint];
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }


          (simObj?.laststate?.stateyear != undefined && simObj?.laststate?.statemonth != undefined) && (chart?.xAxis != undefined) && chart?.xAxis[0]?.update({ min: 1, max: getMonthDays(simObj?.laststate?.stateyear, simObj?.laststate?.statemonth) });

          (inventoryMonthlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "quarterly":
          inventoryQuarterlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm >= simObj?.laststate?.statemonth - 2) {
              return true;
            }
          });
          inventoryQuarterlyData = (inventoryQuarterlyData != undefined ? inventoryQuarterlyData : []).map((data) => {
            return {
              x: (data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm)),
              y: data.fr,
              date: getDate(data.cd),
              externalFailureRate: data.ef,
              internalFailureRate: data.if
            }
          });
          InventoryData["quarterly"] = inventoryQuarterlyData;
          // xAxis.quarterly.min = simObj.laststate.statemonth - 3;
          // xAxis.quarterly.max = simObj.laststate.statemonth;

          if (chart?.series != undefined && InventoryData["quarterly"].length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(InventoryData["quarterly"]);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            newData = [...existingData, inventoryQuarterlyData[inventoryQuarterlyData.length - 1]];

            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }

          let min = 0, max = 0;
          if (simObj?.laststate?.statemonth / 3 >= 0 && simObj?.laststate?.statemonth / 3 <= 1) {
            min = 0;
            max = 3;
          }
          else if (simObj?.laststate?.statemonth / 3 > 1 && simObj?.laststate?.statemonth / 3 <= 2) {
            min = 3;
            max = 6;
          }
          else if (simObj?.laststate?.statemonth / 3 > 2 && simObj?.laststate?.statemonth / 3 <= 3) {
            min = 6;
            max = 9;
          }
          else if (simObj?.laststate?.statemonth / 3 > 3 && simObj?.laststate?.statemonth / 3 <= 4) {
            min = 9;
            max = 12;
          }
          (chart?.xAxis != undefined) && chart?.xAxis[0]?.update({
            // min: simObj.laststate.statemonth-1,
            // max: simObj.laststate.statemonth+2
            min: min,
            max: max
          });
          (inventoryQuarterlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "yearly":
          inventoryYearlyData = simObj?.graphdata;

          inventoryYearlyData = (inventoryYearlyData != undefined ? inventoryYearlyData : []).map((data) => {
            return {
              x: (data?.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data?.sm)),
              y: data.fr,
              date: getDate(data.cd),
              externalFailureRate: data.ef,
              internalFailureRate: data.if
            }
          });
          InventoryData["yearly"] = inventoryYearlyData;

          if (chart?.series != undefined && inventoryYearlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(inventoryYearlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            newData = [...existingData, inventoryYearlyData[inventoryYearlyData.length - 1]];

            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }
          (inventoryYearlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        default:
          break;
      }
    }
  }

  const formatterFunIG = (type) => {

    switch (type) {
      case "monthly":
        return function () {
          return `
            <div className=${`${QmModuleStyle.tooltip}`}>
              <div>Day: ${this.point.date}</div>
              <div>External Failure Rate: ${this.point.externalFailureRate}%</div>
              <div>Internal Failure Rate: ${this.point.internalFailureRate}%</div>           
            </div>
          `;
        };
      case "quarterly":
        return function () {
          return `
            <div className=${`${QmModuleStyle.tooltip}`}>
              <div>Day: ${this.point.date}</div>
              <div>External Failure Rate: ${this.point.externalFailureRate}%</div>
              <div>Internal Failure Rate: ${this.point.internalFailureRate}%</div>              
            </div>
          `;
        };
      case "yearly":
        return function () {
          return `
            <div className=${`${QmModuleStyle.tooltip}`}>
              <div>Day: ${this.point.date}</div>
              <div>External Failure Rate: ${this.point.externalFailureRate}%</div>
              <div>Internal Failure Rate: ${this.point.internalFailureRate}%</div>            
            </div>
          `;
        };
      default:
        return null;
    }

  }
  const InventoryData = {
    "monthly": [],
    "yearly": [],
    "quarterly": []
  }

  function applyAccessibility(chart) {
      if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
          svg.setAttribute("role", "img");
          svg.setAttribute(
          "aria-label",
          "Failure Rate chart showing daily number of failures for the current month."
          );

          const oldDesc = svg.querySelector("desc");
          if (oldDesc) oldDesc.remove();

          const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
          desc.textContent =
          "This bar chart shows the failure rate for each day of the current month. The x-axis represents the days of the month from 1 to 30, while the y-axis shows the number of failures.";
          svg.insertBefore(desc, svg.firstChild);
        },0);
      }
      }
  }

  const xAxis = {
    "monthly": {
      min: 1,
      max: 31,
      step: 1,
      gridLineWidth: 1.5,
      tickInterval: 1,
      tickLength: 0,
      lineColor: '#C6C6C3',
      title: {
        text: "Day of Month",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        },
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.6em'
        }
      }
    },
    "quarterly": {
      // categories: ["",'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      // tickPositions: [9, 10, 11], // Assuming October starts at index 9 in the data array
      gridLineWidth: 1,
      tickInterval: 1,
      tickLength: 0,
      min: 0,
      max: 3,
      labels: {
        formatter: function () {
          const months = window.innerWidth < 1218 ? ["", 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'] : ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
          return months[this.value];
        },
        style: {
          fontSize: '0.8em',
          color: "#000"
        }
      },
      lineColor: '#C6C6C3',
      title: {
        text: "Month",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      rangeSelector: {
        selected: 1
      }
    },
    "yearly": {
      min: 0,
      max: 12, // Use max value as 3 for four quarters (Q1, Q2, Q3, Q4)
      gridLineWidth: 1,
      tickInterval: 3,
      tickLength: 0,
      tickmarkPlacement: 'on',
      lineColor: '#C6C6C3',
      title: {
        text: "Quarter",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        formatter: function () {
          const quarters = ['', '', '', 'Q1', '', '', 'Q2', '', '', 'Q3', '', '', 'Q4'];
          return quarters[this.value];
        },
      },
    }
  }
  const yAxis = {
    "monthly": {
      // min: 0,
      // max: 800,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      allowDecimals: false,
      title: {
        text: "Failure Rate",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        },
      },
      // tickInterval: 200,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        },
      }
    },
    "quarterly": {
      //min: 0,
      // max: 800,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      allowDecimals: false,
      title: {
        text: "Failure Rate",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        },
      },
      // tickInterval: 200,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        },
      }
    },
    "yearly": {
      //min: 0,
      // max: 800,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      allowDecimals: false,
      color: 'rgb(255,255,255)',
      title: {
        text: "Failure Rate",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      // tickInterval: 200,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        }
      },
    }
  }
  graphSettings = {
    chart: {
      type: "column",
      responsive: false,
      marginRight: 14,
      // marginTop: 50,
      marginTop: 8,
      height: 200,
      plotBorderWidth: 1,
      //panning: type === "quarterly",
      events: { 
        render: function () {
            applyAccessibility(this);
        },
        redraw: function () {
            applyAccessibility(this);
        }
      }
    },
    // title: {
    //   text: "<span x=230 style='font-size:14px; font-weight:bold;'>Units left: 382</span> <span x=420 style='font-size:14px; font-weight:bold;'>Demand: 37</span>",
    //   verticalAlign: 'top',
    //   align: 'center',

    // },
    title: {
      text: null
    },
    legend: {
      enabled: false,
      align: "left",
      verticalAlign: "top",
      floating: true,
      visible: true,
      y: -10,
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '14px'
      }
    },

    xAxis: xAxis[type],
    yAxis: yAxis[type],
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        return `Day: ${point.date}; External Failure Rate: ${point.externalFailureRate}%; Internal Failure Rate: ${point.internalFailureRate}%;`;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }   
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Inventory",
        //pointWidth: type === "monthly" ? 16 : type === "quarterly" ? 6 : type === "yearly" ? 0.5 : 0,
        borderWidth: type === "yearly" ? 0.3 : 1,
        borderRadius: 0,
        crisp: type === "quarterly" ? false : type === "yearly" ? false : true,
        states: {
          hover: {
            borderWidth: 1, // Border width on hover
            borderColor: 'black' // Border color on hover
          }
        },
        data: [],
        color: "#467E78",
      }
    ],
    tooltip: {
      enabled: (isResult != undefined && isResult) ? false : true,
      shared: false,
      useHTML: true, // Enable HTML content in tooltip
      headerFormat: '',
      hideDelay: 0,
      formatter: formatterFunIG(type),
      style: {
        color: '#fff'
      },
      valueDecimals: 0,
      backgroundColor: '#000',
      borderColor: '#000',
      borderRadius: 0,
      borderWidth: 3,
    }
  }
  const updateXAxisLabelArray = () => {
    var xAxisLabelArr = [];
    // for (var i = 0; i <= InventoryData[type].length; i++) {
    //   xAxisLabelArr.push(InventoryData[type][i].x);
    // }
    xAxisLabelArr = InventoryData[type].map((data => {
      return data.x;
    }))
    // console.log(xAxisLabelArr);
    setxAxisLabelArray(xAxisLabelArr);
  }
  // const initGraph = () => {
  //   Highcharts.chart("InventoryGraph", graphSettings);
  // }

  function updateSeriesBasedOnWindowWidth() {
    const windowWidth = window.innerWidth;
    if (chart != undefined) {
      if (windowWidth >= 1217) {
        chart?.series != undefined && chart?.series[0].update({
          pointWidth: type === "monthly" ? 8 : type === "quarterly" ? 4 : type === "yearly" ? 0.5 : 0
        });
      } else if (windowWidth <= 1216) {
        chart?.series != undefined && chart?.series[0].update({
          pointWidth: type === "monthly" ? 16 : type === "quarterly" ? 6 : type === "yearly" ? 0.5 : 0
        });
      }
    }
  }
  const graphAccessibility = () => {
    let currReveArr = InventoryData[type].filter((data) => data?.x == xAxisLabelArray[stepCount]);

    let revenueHeading = "";
    let revenueTooltipTxt = "";
    currReveArr?.map((currReveObj) => {
      revenueHeading = `Inventory Tooltip <br/>`
      revenueTooltipTxt = type == "monthly" ? `Day: December ${currReveObj.x} <br/> Units-left: $${currReveObj.unitsLeft} <br/> Demand Cost: $${currReveObj.demandCost} <br/>` : `Day: ${currReveObj.date} <br/> Units-left: $${currReveObj.unitsLeft} <br/> Demand Cost: $${currReveObj.demandCost} <br/>`;
    });

    const monthlydata = revenueHeading + revenueTooltipTxt
    setMonthlyData(monthlydata);
  };
  useEffect(() => {
    graphAccessibility();
  }, [stepCount]);
  useEffect(() => {
    // setGraphData();
    // setGraphSettings();
    updateXAxisLabelArray();
    graphAccessibility();
  }, [type, simObj]);
  useEffect(() => {
    updateSeriesBasedOnWindowWidth();
    window.addEventListener("resize", updateSeriesBasedOnWindowWidth);
    window.addEventListener("load", updateSeriesBasedOnWindowWidth);
  }, [type, chart]);
  useEffect(() => {
    // Initialize the 
    const newChart = Highcharts.chart("Failure-rate-Graph", graphSettings);
    setChart(newChart);
    if (type === "monthly" || type === "quarterly" || type === "yearly") {
      const g_container = QmModuleStyle['graph-container'];
      let gContainer = document.getElementsByClassName(`${g_container}`)[1];
      gContainer.setAttribute("tabindex", '-1');
      gContainer.focus();
    }
  }, [type]);

  useEffect(() => {
    if (isResult && chart != undefined) {
      chart?.series[0]?.setData([]);
      setSimObj((prevObj) => ({
        ...prevObj,
        graphdata: summaryGraphData,
      }));
    }
    else {
      setGraphData();
    }
    if (chart != undefined) {
      document.querySelector("#Failure-rate-Graph .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.laststate?.graphdata, simObj?.currentstep, summaryGraphData]);
  useEffect(() => {
    if (isResult) {
      setGraphData();
    }
  }, [simObj, isResult, summaryGraphData])

  return (
    <div className={`${QmModuleStyle['graph-container']}`} id={type == "monthly" ? "tabpanel-4" : type == "quarterly" ? "tabpanel-5" : "tabpanel-6"} role="tabpanel" aria-labelledby={type == "monthly" ? "tab-4" : type == "quarterly" ? "tab-5" : "tab-6"}>
      {!simObj?.graphdata?.length && <div className={`${QmModuleStyle['nodata-alert-inventory']}`}>Failure rate will appear here as the simulation runs</div>}
      <a href="#" onClick={(e)=> e.preventDefault()} aria-label="Legend: Column for Failure Rate" className="sr-only"></a>
      <div id="Failure-rate-Graph" className={`${QmModuleStyle['inventory-graph']}`}></div>
    </div>
  )
}

export default InventoryGraph